var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H16M8 14H12M21 12C21 16.9706 16.9706 21 12 21C10.843 21 9.73701 20.7817 8.72095 20.384C8.33909 20.2345 7.92598 20.1704 7.5216 20.2385L3.69276 20.8833C3.35374 20.9404 3.05957 20.6463 3.11667 20.3072L3.76147 16.4784C3.82957 16.074 3.76547 15.6609 3.61601 15.279C3.21832 14.263 3 13.157 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
    stroke: "#EBE6FF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.8c8a68943ec871f515e285df87863f2c.svg";
export { ForwardRef as ReactComponent };